var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-table-of-contents",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeText,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.childElementsWithTasks.length > 0
                    ? _c("div", [
                        _vm.currentStyle !== "tiles" && _vm.currentTitle !== ""
                          ? _c(
                              "div",
                              {
                                staticClass: "cw-block-title",
                              },
                              [_vm._v(_vm._s(_vm.currentTitle))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentStyle === "list-details" ||
                        _vm.currentStyle === "list"
                          ? _c(
                              "ul",
                              {
                                class: [
                                  "cw-block-table-of-contents-" +
                                    _vm.currentStyle,
                                ],
                              },
                              _vm._l(
                                _vm.childElementsWithTasks,
                                function (child) {
                                  return _c(
                                    "li",
                                    {
                                      key: child.id,
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to:
                                              "/structural_element/" + child.id,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "cw-block-table-of-contents-title-box",
                                              class: [
                                                child.attributes.payload.color,
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    child.attributes.title
                                                  ) +
                                                  "\n                                "
                                              ),
                                              child.attributes.purpose ===
                                              "task"
                                                ? _c("span", [
                                                    _vm._v(
                                                      " | " +
                                                        _vm._s(child.solverName)
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentStyle ===
                                              "list-details"
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        child.attributes.payload
                                                          .description
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentStyle === "tiles"
                          ? _c(
                              "ul",
                              {
                                staticClass:
                                  "cw-block-table-of-contents-tiles cw-tiles",
                              },
                              _vm._l(
                                _vm.childElementsWithTasks,
                                function (child) {
                                  return _c(
                                    "li",
                                    {
                                      key: child.id,
                                      staticClass: "tile",
                                      class: [child.attributes.payload.color],
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to:
                                              "/structural_element/" + child.id,
                                            title:
                                              child.attributes.purpose ===
                                              "task"
                                                ? child.attributes.title +
                                                  " | " +
                                                  child.solverName
                                                : child.attributes.title,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "preview-image",
                                              class: [
                                                _vm.hasImage(child)
                                                  ? ""
                                                  : "default-image",
                                              ],
                                              style: _vm.getChildStyle(child),
                                            },
                                            [
                                              child.attributes.purpose ===
                                              "task"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "overlay-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(child.solverName)
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "description",
                                            },
                                            [
                                              _c(
                                                "header",
                                                {
                                                  class: [
                                                    child.attributes.purpose !==
                                                    ""
                                                      ? "description-icon-" +
                                                        child.attributes.purpose
                                                      : "",
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        child.attributes
                                                          .title || "–"
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "description-text-wrapper",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        child.attributes.payload
                                                          .description
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "footer",
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.countChildChildren(
                                                          child
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                  _c(
                                                    "translate",
                                                    {
                                                      attrs: {
                                                        "translate-n":
                                                          _vm.countChildChildren(
                                                            child
                                                          ),
                                                        "translate-plural":
                                                          "Seiten",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    Seite\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.viewMode === "edit" &&
                  _vm.childElementsWithTasks.length === 0
                    ? _c("courseware-companion-box", {
                        attrs: {
                          msgCompanion: _vm.$gettext(
                            "Es sind noch keine Unterseiten vorhanden. " +
                              "Sobald Sie weitere Unterseiten anlegen, erscheinen diese automatisch hier im Inhaltsverzeichnis."
                          ),
                          mood: "pointing",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Überschrift")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTitle,
                                    expression: "currentTitle",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentTitle,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTitle = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Layout")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentStyle,
                                      expression: "currentStyle",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentStyle = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "list",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Liste")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "list-details",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Liste mit Beschreibung"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "tiles",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Kacheln")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("translate", [
                    _vm._v("Informationen zum Inhaltsverzeichnis-Block"),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }